module.exports = __webpack_public_path__ + "img/wx.76ea3370.png";